import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { taxCodeEndpoints } from '@/lib/api/endpoints';
import { taxRateKeys } from '@/lib/queryKeys';
import type { TaxRate, TaxRateListResponse } from '@/types/taxRate';

export const SETTINGS_TAX_RATE_LIST_PARAMS = { limit: 100 } as const;

function normalizeTaxRateList(response: TaxRate[] | TaxRateListResponse): TaxRate[] {
  return Array.isArray(response) ? response : response.data;
}

export function useTaxRates() {
  return useApiQuery<TaxRate[]>({
    queryKey: taxRateKeys.list(SETTINGS_TAX_RATE_LIST_PARAMS),
    queryFn: async () => {
      const response = await apiGet<TaxRate[] | TaxRateListResponse>(
        operationsClient,
        taxCodeEndpoints.list(),
        { params: SETTINGS_TAX_RATE_LIST_PARAMS },
      );
      return normalizeTaxRateList(response);
    },
    showErrorToast: false,
  });
}
